import React from 'react';
import PropTypes from 'prop-types';
import { FooterSignUp } from './FooterSignUp';
import { PopupSignUp } from './PopupSignUp';

const NewsLetter = ({
  footerHeading,
  footerContent,
  campaignId,
  giftImage,
  popupEnabled,
  popupHero,
  popupHeading,
  popupContent,
  secsToPopup,
  daysNotToShow,
  closedCountMax,
}) => (
  <>
    <FooterSignUp
      footerHeading={footerHeading}
      footerContent={footerContent}
    />
    {popupEnabled && (
      <PopupSignUp
        campaignId={campaignId}
        giftImage={giftImage}
        popupHero={popupHero}
        popupHeading={popupHeading}
        popupContent={popupContent}
        secsToPopup={secsToPopup}
        daysNotToShow={daysNotToShow}
        closedCountMax={closedCountMax}
      />
    )}
  </>
);

NewsLetter.propTypes = {
  footerHeading: PropTypes.string.isRequired,
  footerContent: PropTypes.string.isRequired,
  campaignId: PropTypes.string,
  popupEnabled: PropTypes.bool,
  giftImage: PropTypes.string,
  popupHero: PropTypes.string.isRequired,
  popupHeading: PropTypes.string.isRequired,
  popupContent: PropTypes.string.isRequired,
  secsToPopup: PropTypes.string.isRequired,
  daysNotToShow: PropTypes.string.isRequired,
  closedCountMax: PropTypes.string.isRequired,
};

NewsLetter.defaultProps = {
  giftImage: null,
  campaignId: '',
  popupEnabled: false
};

export { NewsLetter };
